import { Component, OnInit , ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GeneralLedgerService } from '../../services/general-ledger.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
	selector: 'app-sales-gl-postings',
	templateUrl: './sales-gl-postings.component.html',
	styleUrls: ['./sales-gl-postings.component.scss'],
	animations: [
		trigger('expandCollapse', [
			state('void', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
			state('*', style({ height: '*', opacity: 1 })),
			transition('void <=> *', [animate('300ms ease-in-out')]),
		]),
	],
})
export class SalesGLPostingsComponent implements OnInit {
	salesGLForm: FormGroup;
	salesGLPostings: any[] = [];
	areas: any[] = [];
	stockCategories: any[] = [];
	salesTypes: any[] = [];
	glCodes: any[] = [];
	editingPost: any = null;
	isLoading = false;
	color = 'blue';
	isFormVisible = false;
	searchTerm = '';

	@ViewChild('salesGLModal') salesGLModal: any;
	constructor(
		private fb: FormBuilder,
		private glService: GeneralLedgerService,
		private snackBar: MatSnackBar,
		private location: Location,
		private globalSearchService: GlobalSearchService,
		private dialog: MatDialog,
	) {
		this.color = this.globalSearchService.getColor();
		this.salesGLForm = this.fb.group({
			area: ['', Validators.required],
			stkcat: ['', Validators.required],
			salestype: ['', Validators.required],
			salesglcode: ['', Validators.required],
			discountglcode: ['', Validators.required],
		});

	}

	toggleForm(): void {
		this.isFormVisible = !this.isFormVisible;
	}



	filterSalesGLPostings(): any[] {
		return this.salesGLPostings.filter(post =>
			Object.values(post).some(value =>
				value?.toString().toLowerCase().includes(this.searchTerm.toLowerCase())
			)
		);
	}

	// Reset and open form for new posting
	resetAndOpenForm(): void {
		this.resetForm();
		this.isFormVisible = true;
	}
	// Open modal
	openSalesGLModal(post?: any): void {
		if (post) {
			this.editingPost = post;
			this.salesGLForm.patchValue(post);
		} else {
			this.resetForm();
		}
		this.dialog.open(this.salesGLModal);
	}

	// Save posting
	saveSalesGLPosting(): void {
		if (this.salesGLForm.valid) {
			if (this.editingPost) {
				// Update
				const data = { ...this.salesGLForm.value, id: this.editingPost.id };
				this.glService.updateSalesGLPosting(data).subscribe(() => {
					this.isFormVisible = false;
					this.snackBar.open('Posting updated successfully.', 'Close', { duration: 3000 });
					this.loadSalesGLPostings();
					this.dialog.closeAll();
					this.resetForm();
				});
			} else {
				// Add
				this.glService.addSalesGLPosting(this.salesGLForm.value).subscribe((r:any) => {
					if(r.error) {
						this.snackBar.open(r.error, 'Close', { duration: 3000 });
					} else {
						this.snackBar.open('Posting added successfully.', 'Close', { duration: 3000 });
					}
					this.loadSalesGLPostings();
					this.dialog.closeAll();
					this.resetForm();
				});
			}
		}
	}

	// Reset the form
	resetForm(): void {
		this.editingPost = null;
		this.salesGLForm.reset();
	}

	ngOnInit(): void {
		this.loadSalesGLPostings();
		this.loadDependencies();
	}

	loadSalesGLPostings(): void {
		this.isLoading = true;
		this.glService.fetchSalesGLPostings({}).subscribe(
			(response) => {
				this.salesGLPostings = response.data || [];
				this.isLoading = false;
				this.filterSalesGLPostings();
			},
			(error) => {
				this.snackBar.open('Error loading Sales GL Postings.', 'Close', { duration: 3000 });
				this.isLoading = false;
			}
		);
	}

	loadDependencies(): void {
		this.glService.fetchAreas().subscribe(
			(res) => {
				this.areas = res.areas.map((area: any) => ({ name: area.name, code: area.code }));
			},
			(error) => {

			}
		);

		this.glService.fetchStockCategories().subscribe(
			(res) => {
				this.stockCategories = res.stockCategories.map((category: any) => ({ name: category.name, code: category.code }));
			},
			(error) => {

			}
		);

		this.glService.fetchSalesTypes().subscribe(
			(res) => {
				this.salesTypes = res.salesTypes.map((type: any) => ({ name: type.name, code: type.code }));
			},
			(error) => {

			}
		);

		this.glService.fetchGLCodes().subscribe(
			(res) => {
				this.glCodes = res.glCodes.map((code: any) => ({ name: code.name, code: code.code }));
			},
			(error) => {

			}
		);
	}

	deletePosting(id: string): void {
		if (!confirm('Are you sure you want to delete this posting?')) {return;}

		this.glService.deleteSalesGLPosting({ id }).subscribe(
			() => {
				this.snackBar.open('Sales GL Posting deleted successfully.', 'Close', { duration: 3000 });
				this.loadSalesGLPostings();
			},
			() => this.snackBar.open('Error deleting Sales GL Posting.', 'Close', { duration: 3000 })
		);
	}

	editPosting(post: any): void {
		this.editingPost = post;
		this.salesGLForm.patchValue(post);
		this.isFormVisible = true;
	}



	back(): void {
		this.location.back();
	}
}